<template>
  <div id="Password">
    <Navbar :title="$t('交易密码')" />
    <LoginForm :formList="formList" confirmText="newAdd.Submit" @submit="onSubmit">
      <template #read>
        <div class="text">{{ $t("My.PersonalInformation.Password.Text") }}</div>
      </template>
      <template #cancel>
        <div></div>
      </template>
    </LoginForm>
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import LoginForm from "@/view/login/components/form.vue";
import { SETTING_PAY_PDW } from "@/api"
import {
  Toast,
} from "vant";

export default {
  name: "portrait",
  components: {
    [Toast.name]: Toast,
    Navbar,
    LoginForm,
  },
  data() {
    return {
      userInfo: {},
      formList: [{
        key: "newpass",
        icon: "icon-mima",
        label: "My.PersonalInformation.Password.ConfirmPasswordNote",
      }, {
        key: "confirmpass",
        icon: "icon-mima",
        label: "确认新密码",
      }]
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    onSubmit(values) {
      const { oldpass, newpass, confirmpass } = values;
      if (this.userInfo.setpaypass > 0) {
        if (!oldpass) return Toast(this.$t('My.PersonalInformation.Password.oldPass'))
      }
      if (!newpass) return Toast(this.$t('My.PersonalInformation.Password.ConfirmPasswordNote'));
      if (!confirmpass) return Toast(this.$t('确认新密码'));
      if (newpass != confirmpass) return Toast(this.$t('两次密码不一致'))
      Toast.loading({ duration: 0 });
      SETTING_PAY_PDW({ oldpass, newpass }).then(res => {
        const {ret,msg} = res.data
        Toast.clear();
        if(ret == 1){
          Toast(msg)
          setTimeout(()=>{
            this.getUserInfo();
            this.$router.back()
          },1000)
          return
        }
        return Toast(msg)
      })

    },
    getUserInfo() {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      this.$api.getUserInfo((res) => {
        Toast.clear();
        this.userInfo = res;
        if (res.setpaypass > 0) {
          this.formList = [{
            key: "oldpass",
            icon: "icon-mima",
            label: "My.PersonalInformation.Password.oldPass",
          }, ...this.formList]
        }
      }, (err) => {
        Toast.clear();
        this.$toast(err);
      });
    },
  },
};
</script>

<style lang="less" scoped>
#Password {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: #F5F5F9;

  .text {
    color: #5e5e5e;
    font-size: 0.75rem;
    margin-top: calc(20rem / 16);
  }

  /deep/ .form_list {
    .van-cell {
      background-color: #efefef !important;
      padding: 0 20px;
      border-radius: calc(10rem / 16);

      .van-field__body {
        height: 52px;
        line-height: 52px;
        background-color: transparent;
        padding: 0 0 0 10px;
      }

      input {
        color: #333;
      }
    }

    .iconfont {
      color: #a5a5a5;
    }

    .confirm {
      background: linear-gradient(90deg,#bead6e,#99793a) !important;
      color: #fffefe !important;
      font-size: calc(14rem / 16);
      border-radius: calc(7.5rem / 16) !important;
      height: calc(52rem / 16);
      line-height: calc(52rem / 16);
      text-align: center;
      margin-top: calc(30rem / 16);
    }
  }

}
</style>